import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { EP2_quest2Data, EP2_quest2Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F32.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame32() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest1 = useSelector(EP2_quest2Data);

        return (
            <div className="F32_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F32_entryBox">
                    <div className="F32_heading">
                        {
                            language === 'english' ?
                                <p className="F32_headingEnglish">Saira asks her teacher if it is possible to know when periods occur for the first time? How should teacher respond to this?</p>
                                :
                                <p className="F32_headingUrdu">سائرہ اپنی ٹیچر سے پوچھتی ہے کہ کیا یہ ممکن ہے کہ ماہواری کے آنے کا پہلے ہی سے پتا چل جائے؟</p>
                        }
                    </div>
                    <div className="F32_options">
                        <div onClick={() => { dispatch(EP2_quest2Selected('A'), dispatch(pageUp())) }} className={language === 'english' ? "F32_option" : "F32_optionUrdu"}>
                            {language === 'english' ? `A. ${quest1.headingEnglish.A}` : `${quest1.headingUrdu.A}`}
                        </div>

                        <div onClick={() => { dispatch(EP2_quest2Selected('B'), dispatch(pageUp())) }} className={language === 'english' ? "F32_option" : "F32_optionUrdu"}>
                            {language === 'english' ? `B. ${quest1.headingEnglish.B}` : `${quest1.headingUrdu.B}`}
                        </div>

                    </div>

                    <div className="F32_timeline">
                        <div className='F32_timelineBar'>
                            <div className='F32_timelineFill'></div>
                            <span className='F32_timelineText'>8/19</span>
                        </div>
                    </div>

                    <div className="F32_nextFrames">
                        <div className="F32_nextFrame1"></div>
                        <div className="F32_nextFrame2"></div>
                        <div className="F32_nextFrame3"></div>
                    </div>

                </div>
            </div>
        )
}

export default Frame32;